import axios from 'axios'
import { lib } from '@giscube/geoportal'
const L = lib.L
import { interpolate } from 'src/lib/geovideoInterpolate.js'

function interpolateCoordinateSeconds (axis, coordinatesSeconds, map) {
  if (axis === null) {
    return []
  }
  const axisList = axis.coordinates.map(item => [item[1], item[0]])
  const linestring = L.polyline(axisList).addTo(map)
  const interpolated = interpolate(linestring, coordinatesSeconds, map)
  map.removeLayer(linestring)
  return interpolated
}

function formatPlaylist (playlist, media, map) {
  if (!playlist || playlist.length === 0) {
    return []
  }
  return playlist.map(video => {
    video.url = video.url.startsWith('http') ? video.url : media + video.url
    video.coordinatesSeconds = interpolateCoordinateSeconds(video.geometry, video.coordinatesSeconds, map)
    return video
  }).filter(video => video.coordinatesSeconds && video.coordinatesSeconds.length > 0)
}

export function fetchPlaylist (context, latlng) {
  context.commit('setCurrentVideoIndex', null)
  context.commit('setFetchingPlaylist', true)
  const api = this.$config.panoramas.geovideosApi
  const config = {
    headers: context.rootGetters['auth/headers'],
    params: {
      p: `${latlng.lat},${latlng.lng}`,
      r: 250
    }
  }
  const media = this.$config.panoramas.media
  return axios.get(api, config)
    .then(({ data }) => {
      context.commit('setNoPlaylistFound', !(data && data.length > 0))
      const playlist = formatPlaylist(data, media, context.rootState.map.mapObject)
      context.commit('setPlaylist', playlist)
      context.commit('setCurrentVideoIndex', 0)
    })
    .catch(error => {
      console.error(error)
      context.commit('setPlaylist', [])
      context.commit('setCurrentVideoIndex', 0)
    })
    .finally(() => {
      context.commit('setFetchingPlaylist', false)
      return null
    })
}
